import React, { useMemo, useState } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import {
  AsyncTypeahead,
  Typeahead,
  TypeaheadMenu,
  Input,
  Hint,
} from 'react-bootstrap-typeahead';

let formId = 0;

export const TypeAheadWrapper = ({ url, items, name, onChange, selected }) => {
  const id = `typeahead-form-${useMemo(() => formId++, [])}`;
  const [state, setState] = useState({
    isLoading: false,
    organisations: [],
  });
  const [isOpen, setIsOpen] = useState(false);
  const commonProps = {
    selected,
    onChange,
    className: classNames(
      `typeahead__component`,
      isOpen && 'typeahead__component--open'
    ),
    id,
    minLength: 3,
    onMenuToggle: setIsOpen,
    inputProps: { name },
    renderMenu(results, menuProps, parentProps) {
      return (
        <div className="typeahead__menu-overlay">
          <div className="typeahead__menu-wrapper">
            <TypeaheadMenu
              {...menuProps}
              style={undefined}
              className="typeahead__menu"
              labelKey={parentProps.labelKey}
              options={results}
              text={parentProps.text}
            />
          </div>
          <p className="typeahead__menu-hint">
            <span className="stack stack--center stack--space-1">
              <span>
                Remember to try alternative spellings and abbreviations
              </span>
              <a className="typeahead__menu-link" href="#">
                I can&apos;t find my organisation
              </a>
            </span>
          </p>
        </div>
      );
    },
    // eslint-disable-next-line react/prop-types
    renderInput({ inputRef, referenceElementRef, ...inputProps }) {
      return (
        <Hint className="typeahead__placeholder-hint">
          <Input
            {...inputProps}
            ref={node => {
              inputRef(node);
              referenceElementRef(node);
            }}
          />
        </Hint>
      );
    },
  };

  if (url) {
    return (
      <AsyncTypeahead
        {...commonProps}
        isLoading={state.isLoading}
        useCache={false}
        onSearch={async query => {
          setState({ isLoading: true });
          try {
            let response = await fetch(url + `?q=${query}`);

            while (response.status === 202) {
              await new Promise(r => setTimeout(r, 500));
              response = await fetch(url + `?q=${query}`);
            }

            setState({
              organisations: await response.json(),
              isLoading: false,
            });
          } catch (err) {
            setState({ isLoading: false });
            throw err;
          }
        }}
        options={state.organisations}
      />
    );
  } else if (items) {
    return <Typeahead {...commonProps} options={items} />;
  }

  return null;
};

TypeAheadWrapper.propTypes = {
  url: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      id: PropTypes.string,
    })
  ),
  name: PropTypes.string,
  onChange: PropTypes.func,
  selected: PropTypes.string,
};

export const TypeAhead = ({ labelText, hint, ...rest }) => (
  <label className="typeahead">
    {labelText}
    <TypeAheadWrapper {...rest} />
    {hint && <span className="typeahead__hint">{hint}</span>}
  </label>
);

TypeAhead.propTypes = {
  ...TypeAheadWrapper.propTypes,
  labelText: PropTypes.string.isRequired,
  hint: PropTypes.node,
};
